const getOnChangeHandler = ({ onChange, setSearchTerm }) => ({
  target: { value: searchTerm }
}) => {
  onChange({ searchTerm });
  setSearchTerm(searchTerm);
};

export default getOnChangeHandler;
